import _implicitStylesheets from "./tabGroupV2.css";
import _implicitScopedStylesheets from "./tabGroupV2.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<span class="tab-menu-trigger-label${0}"${"a0:type-style"}${2}>${"t1"}</span>`;
const $fragment2 = parseFragment`<li active role="presentation"${3}><a${"a1:id"}${"a1:tab-key"}${"a1:href"}${"a1:type-style"} role="tab" aria-selected="true" tabindex="0"${3}>${"t2"}</a></li>`;
const $fragment3 = parseFragment`<li role="presentation"${3}><a${"a1:id"}${"a1:tab-key"}${"a1:href"}${"a1:type-style"} role="tab" aria-selected="false" tabindex="-1"${3}>${"t2"}</a></li>`;
const stc0 = {
  "tab-menu-trigger-chevron": true
};
const stc1 = {
  "role": "tablist"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, k: api_key, gid: api_scoped_id, fid: api_scoped_frag_id, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [$cmp.showMobileDropdown ? api_element("button", {
    className: api_normalize_class_name($cmp.triggerClass),
    attrs: {
      "type": "button",
      "aria-haspopup": "true",
      "aria-expanded": $cmp.dropdownExpanded
    },
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggleDropdown)),
      "keydown": _m1 || ($ctx._m1 = api_bind($cmp.handleTriggerKeydown))
    }
  }, [api_static_fragment($fragment1, 2, [api_static_part(0, {
    attrs: {
      "type-style": $cmp.responsiveState.tabTypeStyle
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.activeTabLabel))]), api_custom_element("ax-icon", _axIcon, {
    classMap: stc0,
    props: {
      "icon": $cmp.dropdownChevronIcon,
      "size": "xsmall",
      "ariaHidden": "true"
    },
    key: 3
  })]) : null, api_element("ul", {
    className: api_normalize_class_name($cmp.listClass),
    attrs: stc1,
    key: 4,
    on: {
      "keydown": _m2 || ($ctx._m2 = api_bind($cmp.handleTabKeydown)),
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleTabListClick))
    }
  }, api_iterator($cmp.renderTabs, function (tab) {
    return [tab.active ? api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": tab.id,
        "label": tab.label,
        "href": tab.url
      },
      key: api_key(5, tab.label),
      on: {
        "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment2, 7, [api_static_part(1, {
      attrs: {
        "id": api_scoped_id(tab.anchorId),
        "tab-key": tab.anchorId,
        "href": api_scoped_frag_id(tab.url),
        "type-style": $cmp.responsiveState.tabTypeStyle
      }
    }, null), api_static_part(2, null, api_dynamic_text(tab.label))])]) : null, !tab.active ? api_custom_element("wds-link", _wdsLink, {
      props: {
        "name": tab.id,
        "label": tab.label,
        "href": tab.url
      },
      key: api_key(8, tab.label),
      on: {
        "analytics": _m5 || ($ctx._m5 = api_bind($cmp.handleAnalytics))
      }
    }, [api_static_fragment($fragment3, 10, [api_static_part(1, {
      attrs: {
        "id": api_scoped_id(tab.anchorId),
        "tab-key": tab.anchorId,
        "href": api_scoped_frag_id(tab.url),
        "type-style": $cmp.responsiveState.tabTypeStyle
      }
    }, null), api_static_part(2, null, api_dynamic_text(tab.label))])]) : null];
  }))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-76oc1peebmp";
tmpl.legacyStylesheetToken = "undefined-_tabGroupV2";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
